import { GetterTree } from 'vuex'
import { RootState } from '../types'
import { FacebookState } from './types'

export const mutations: GetterTree<FacebookState, RootState> = {}
export default mutations
